export const DEAL_PHASES = [
  { key: 'posted', label: 'Deal Posted' },
  { key: 'admin_review', label: 'Admin Review' },
  { key: 'matching', label: 'LP Matching' },
  { key: 'nda', label: 'NDA Signed' },
  { key: 'dd', label: 'Due Diligence' },
  { key: 'term_sheet', label: 'Term Sheet' },
  { key: 'escrow', label: 'Escrow Funding' },
  { key: 'closed', label: 'Deal Closed' },
]
